<script>
    import { getContext } from 'svelte'

    import { CornerItem } from '@/components'

    export let num = 0
    export let data = {
        width: 0,
        height: 0,
        corner: 'left-top'
    }

    const { mobileType } = getContext('adaptive')

    $: style = (() => {
        const { width, height, top, left, right } = (data[$mobileType] ? { ...data.desktop, ...data[$mobileType] } : data.desktop)


        let result = `
            width: ${width}px; 
            height: ${height}px; 
            box-shadow: 40px 56px 88px rgba(101, 34, 142, 0.84), 6px 4px 74px #B868E9;
            position: absolute;
        `

        if (typeof top !== 'undefined'){
            result += ` top: ${top}px;`
        }

        if (typeof left !== 'undefined'){
            result += ` left: ${Number.isInteger(left) ? left+'px' : left};`
        }

        if (typeof right !== 'undefined'){
            result += ` right: ${right}px;`
        }

        return result 
    })()
</script>

<CornerItem class="corner-item" corner={data.corner} {style}>
    <div class="num-wrapper">
        <img src={`./img/icons/nums/${num}.png`} />
    </div>
    <div class="description">{@html data.description}</div>
</CornerItem>

<style lang="scss" module>
    .num-wrapper {
        position: absolute;
        top: -50px;
        left: -75px;
        width: 141px;
        height: 141px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .description {
        font-size: 20px;
        line-height: 25px;
        text-align: center;
    }

    @media (max-width: 420px) {
        .corner-item {
            position: relative !important;
            width: 100% !important;
            height: 210px !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            margin-bottom: 130px;

            &:last-of-type {
                margin-bottom: 0;
            }

            .num-wrapper {
                width: 92px;
                height: 92px;
                top: -75px;
                left: calc(50% - 92px / 2);
            }

            .description {
                font-size: 14px;
                line-height: 18px;
            }
        }
    }
</style>